import { axios } from '@/utils/request'

/**
 * 获取可购买的活动
 * @param {*} userId 登录用户ID
 * @param {*} activityType 活动类型
 * @param {*} courseType 课程类型
 * @param {*} suitableAge 适用年龄
 * @param {*} status 活动状态
 * @param {*} limit 返回数量
 */
export function getActivityList(userId, activityType, courseType, suitableAge,status, limit) {
    return axios({
        url: "/teaching/teachingActivity/getActivityList",
        method: "get",
        params: {
            userId, activityType, courseType, suitableAge,status, limit
        }
    })
}

/**
 * 获取活动信息
 */
export function getActivityDetail(id){
    return axios({
        url: "/teaching/teachingActivity/getActivityDetail?activityId=" + id,
        method: "get",
    })
}
